
















import Vue from "vue";
import { store } from "../services/store";

import TaskNoCurrent from "./task/TaskNoCurrent.vue";
import TaskInProgress from "./task/TaskInProgress.vue";
import TaskFinished from "./task/TaskFinished.vue";
import TaskQuit from "./task/TaskQuit.vue";

export default Vue.extend({
  name: "Task",
  components: {
    TaskNoCurrent,
    TaskInProgress,
    TaskFinished,
    TaskQuit
  },
  computed: {
    status() {
      // 任务状态，0:未激活 1:无进行中  2:进行中 3:已完成 4:已过期 5:已退出
      return store.status;
    },
    canRenderTask() {
      // 是否能渲染任务模块
      return store.canRenderTask;
    }
  },
  methods: {
    share() {
      this.$emit("share");
    },
    scroll() {
      this.$emit("scroll");
    }
  }
});
